export const getCardBrand2 = (number) => {
    if (number.match(new RegExp("^4")) != null) return "VISA";
    if (number.match(new RegExp("^377717|^374(354|371)")) != null) return "Dillards AMEX Charge";
    if (number.match(new RegExp("^519457")) != null) return "Dillards Mastercard";
    if (number.match(new RegExp("^3[47]")) != null) return "AMEX";
    if (number.match(new RegExp("^579674|604587")) != null) return "Dillards Charge";
    if (number.match(new RegExp("^603537")) != null) return "Dillards Private Label";
    if (number.match(new RegExp("^5[1-5]|^2[2-7]")) != null) return "Master Card";
    if (number.match(new RegExp("^30[0-5]|^308[8-9]|^309[0-9]|^310[0-2]|^311[2-9]|^3120|^315[8-9]|" +
    							"^333[7-9]|^334[0-9]|^352[8-9]|^35[3-8]|^3[6,8]|^6011[0-4]|^60117[4,7-9]|" +
    							"^60118[6-9]|^60119|^62212[6-9]|^6221[3-9]|^622[2-8]|^6229[0,1]|^62292[0-5]|" +
    							"^62[4-6]|^628[2-9]|^644|^65|^810[0-9]|^811[0-9]|^812[0-9]|^813[0-9]|^814[0-9]|" +
    							"^815[0-9]|^816[0-9]|^817[0,1]")) != null) 
    	return "Discover";
    return "";
};
